import { FC } from 'react';
import CustomLink from '@components/CustomLink';
import classNames from 'classnames';
import s from './TermsAndPolicy.module.scss';

const TermsAndPolicy: FC<{ isSignIn?: boolean; isCreatorView?: boolean }> = ({ isSignIn, isCreatorView = false }) => (
  <p
    className={classNames(s.wrapper, {
      [s.creatorWrapper]: isCreatorView,
    })}
  >
    By signing {isSignIn ? 'in' : 'up'}, you agree to our <CustomLink to="https://www.glade.ai/terms-and-conditions">Terms of Use</CustomLink> and{' '}
    <CustomLink to="https://www.glade.ai/privacy-policy">Privacy Policy</CustomLink>.
  </p>
);

export default TermsAndPolicy;
